import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { Helmet } from "react-helmet";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import Modal from "../../../aGlobalDesign/Modal/Modal";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";

class CallCategoriesList extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            selectedCallCategory: null,
            temporaryElement: null,
            forcePaginationUpdate: 0,
            restrictedZones: null
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.callCategories);
        this.props.ChangeCurrentMenuName("CallCategories");
        this.GetRestrictedZones();
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedCallCategory: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }
        if (this.props.createNew !== prevProps.createNew) {
            this.OnLoad(null);
        }
    }

    //#region functions
    GetRestrictedZones(onSuccess) {
        if (!this.state.restrictedZones) {
            this.props.GetRestrictedZones(
                (data) => {
                    this.setState({
                        restrictedZones: data
                    });
                    if (onSuccess) {onSuccess(data);}
                },
                this.props.currentuser.accessrights ? this.props.currentuser.accessrights.hasPermission(300, "create") : 0
            );
        }
        else if (onSuccess) {
            onSuccess(this.state.restrictedZones);
        }
    }
    OnDelete(id, onSuccess) {
        this.props.OpenDialog({
            title: strings.deleteConfirm,
            description: strings.textDeleteItem,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.DeleteCallCategory(id, () => {
                    this.forcePaginationUpdate();
                });
            }
        });
    }
    OnLoad(callCategory) {
        let d = callCategory;
        this.GetRestrictedZones((zones) => {
            const zoneId = zones && zones.results && zones.results.length > 0 && this.props.currentuser.accessrights.hasPermission(300, "create") === 20 ? zones.results[0].id :
                this.props.administration.secondaryzones.results ? this.props.administration.secondaryzones.results[0].id : null;
            if (d === null) {
                d = {
                    id: 0,
                    name: "",
                    zoneId: zoneId,
                    organizationId: this.props.currentuser.currentorganization.id
                };
            }
            const temp = this.CreateTemp(d);
            this.setState({
                selectedCallCategory: d,
                temporaryElement: temp
            });
        });
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            name: element.name,
            zoneId: element.zoneId,
            organizationId: element.organizationId
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        element.description = temp.description;
        element.zoneId = temp.zoneId;
        return element;
    }
    saveSelectedCallCategory() {
        const display = this.state.selectedCallCategory;
        this.SaveTemp(this.state.temporaryElement, display);
        if ( display.name === "") {
            this.props.OpenDialog({
                description: strings.alertName,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const d = {
            id: display.id,
            name: display.name,
            zoneId: display.zoneId,
            organizationId: this.props.currentuser.currentorganization.id
        };

        if (display.id === 0) {
            this.props.CreateCallCategory(d,
                (id) => {
                    this.forcePaginationUpdate();
                });
        }
        else {
            this.props.EditCallCategory(
                d,
                (updatedDisplayTimestamp) => {
                    this.forcePaginationUpdate();
                }
            );
        }
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={this.props.GetCategoriesList}
                onSavePagination={this.props.SaveCategoriesPagination}
                myElements={this.props.administration.callcategories}

                sortOptions={[
                    { sortName: "name", sortData: "asc" },
                    { sortName: "zone", sortData: "null" }
                ]}

                tableElement={(element, onReloadList) => {
                    return [
                        {
                            colTitle: strings.SortName,
                            sortIndex: 0,
                            fixedWidth: "400px",
                            colContent: element ? element.name : null
                        },
                        {
                            colTitle: strings.Zone,
                            sortIndex: 1,
                            fixedWidth: "400px",
                            colContent: element ? element.zone.name : null
                        },
                        {
                            colTitle: strings.actions,
                            colType: "actions",
                            actions: [1, 2],
                            colContent: [
                                <ButtonSkaRound
                                    key={"edit"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(300, "modify") <= 10}
                                    onClick={() => this.OnLoad(element)}
                                    nameIcon="edit"
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(300, "delete") <= 10}
                                    onClick={() => this.OnDelete(element.id)}
                                    nameIcon="trash"
                                />
                            ]
                        }
                    ];
                }}
            />
            <Modal open={this.state.selectedCallCategory !== null}
                onClose={() => {
                    if (!this.state.preview) {
                        this.forcePaginationUpdate();
                    }
                    else {
                        this.setState({
                            preview: false,
                            selectedCallCategory: null
                        });
                    }
                }}
                onValidate={!this.state.preview ? () => this.saveSelectedCallCategory() : null }
                title={this.state.preview ? strings.CallCategories : this.state.selectedCallCategory && this.state.selectedCallCategory.id !== 0 ? strings.editCallCategory : strings.addCallCategory}
                icon={this.state.preview ? "information" : this.state.selectedCallCategory && this.state.selectedCallCategory.id !== 0 ? "edit" : "add"}
                fields={
                    this.state.selectedCallCategory ? [
                        {
                            type: "textfield",
                            title: strings.name,
                            disabled: this.state.preview,
                            placeholder: strings.name,
                            value: this.state.temporaryElement.name,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.name = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "selectElement",
                            title: strings.Zone,
                            disabled: this.state.temporaryElement.id !== 0,
                            openTop: true,
                            adjustHeight: true,
                            elementsList: this.state.restrictedZones,
                            selectedElementId: this.state.temporaryElement.zoneId,
                            onSelectElement: (element) => {
                                const dp = this.state.temporaryElement;
                                dp.zoneId = element ? element.id : null;
                                dp.zone = element;
                                this.setState({ filters: dp });
                            }
                        }
                    ] : null
                }
            />
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(CallCategoriesList);
